import { useEffect, useState } from 'react';
import { apiFetch } from './api';

// Loads the org's feature flags once and caches them. feature(key) defaults to
// true (fail-open for UI) until loaded, so nothing flickers hidden on first paint
// for enabled-by-default modules.
let _cache = null;
const DEFAULT_ON = new Set([
  'chat.enabled','knowledge.enabled','projects.enabled','plan.enabled','oof.enabled',
  'subtickets.enabled','reports.enabled','attachments.enabled','email_to_ticket.enabled',
  'customer_reopen.enabled','sla_stop.enabled','sla_auto_resume.enabled','auto_assign.enabled','team_chat.enabled',
]);

export function useFeatures() {
  const [cfg, setCfg] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    apiFetch('/settings/public')
      .then(d => { _cache = d; setCfg(d); })
      .catch(() => { _cache = { flags: {}, values: {} }; setCfg(_cache); });
  }, []);
  const flags = cfg?.flags || null;
  const feature = (key) => {
    if (!flags) return DEFAULT_ON.has(key); // pre-load default
    return flags[key] !== false;
  };
  return { feature, values: cfg?.values || {}, tenant: cfg?.tenant || null, loaded: !!cfg };
}

export function clearFeatureCache() { _cache = null; }
